
const BuyerPricingHero = () => {
  return (
    <div className="text-center mb-12">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        Simple, <span className="text-[#ffd700]">Transparent</span> Pricing
      </h1>
      <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
        Buyer accounts are completely free - no credit card required
      </p>
    </div>
  );
};

export default BuyerPricingHero;
